/**
 * Copyright (c) Microsoft. All rights reserved.
 */

type ResizeState = { knob: 'start' | 'end'; label: { start: number; end: number } };

/**
 * Reducer function that captures the resize state and allows changes to it.
 */
export const resizeReducer = (state: ResizeState, action: { tokenIndex: number }): ResizeState => {
    const { knob, label } = state;
    if (knob === 'start') {
        if (action.tokenIndex > label.end) {
            return { knob: 'end', label: { start: label.start, end: action.tokenIndex } };
        }
        return { knob, label: { start: action.tokenIndex, end: label.end } };
    }
    if (knob === 'end') {
        if (action.tokenIndex < label.start) {
            return { knob: 'start', label: { start: action.tokenIndex, end: label.end } };
        }
        return { knob, label: { start: label.start, end: action.tokenIndex } };
    }
};
